import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import ErrorBoundary from '../components/common/helpers/ErrorBoundary';
import DashboardScene from '../components/scenes';
const Dashboard = () => {
  const $ = _c(4);
  const [is_client, setIsClient] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => setIsClient(true);
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== is_client) {
    t2 = is_client && <BrowserRouter basename="/"><ErrorBoundary><DashboardScene /></ErrorBoundary></BrowserRouter>;
    $[2] = is_client;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
Dashboard.configs = {
  title: 'Dashboard',
  desc: 'View, manage and configure your Hookdeck projects',
  disable_tracking: true
};
export default Dashboard;